/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgPlaceholder241(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='#6F757C'
        fillRule='evenodd'
        d='M4.67 3.903C7.423 1.806 11.332.25 16 .25h5A2.75 2.75 0 0123.75 3v20.75H.25V11c0-2.333 1.706-5.028 4.42-7.097zm.91 1.194C3.406 6.752 2.145 8.683 1.829 10.25H22.25V3A1.25 1.25 0 0021 1.75h-5c-4.332 0-7.923 1.444-10.42 3.347zM1.75 22.25v-10.5h20.5v10.5H1.75zm18-8h-5.5v1.5h5.5v-1.5z'
      />
    </svg>
  );
}

export default SvgPlaceholder241;
